import { render } from "./wnRecharge.vue?vue&type=template&id=4d5fbdc8&scoped=true"
import script from "./wnRecharge.vue?vue&type=script&lang=js"
export * from "./wnRecharge.vue?vue&type=script&lang=js"

import "./wnRecharge.vue?vue&type=style&index=0&id=4d5fbdc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d5fbdc8"

export default script